import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=3905aef5&scoped=true&"
import script from "./TaskEdit.vue?vue&type=script&lang=ts&"
export * from "./TaskEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TaskEdit.vue?vue&type=style&index=0&id=3905aef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905aef5",
  null
  
)

export default component.exports